import { useState, useEffect } 	from "react";
import { Box, Card, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Link } from "react-router-dom";
import moment from "moment";

import useInternalFetch from "../../../api/apiInternal";
import config from "../../../common/Config";

const LastUpdatesCard = () => {

	const internalFetch						= useInternalFetch()
	const [lastUpdates, setLastUpdates] 	= useState([])

	useEffect(() => {
		const from = moment().subtract(30, 'days').format('YYYY-MM-DD')
		const to   = moment().format('YYYY-MM-DD')
		const params = new URLSearchParams({ portfolioOnly: '1', from, to, limit: '5' })
		internalFetch(config.apiUrl + '/api/recent-earnings?' + params)
			.then(d => setLastUpdates(Array.isArray(d) ? d : []))
	}, [])

	return (
		<Card sx={{height:'100%'}}>
			<CardContent>
				<Typography variant="h6" mb={1}>Últimas atualizações</Typography>
				<TableContainer component={Paper}>
						<Table size="small">
							<TableHead >
								<TableRow>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700', padding: 0}}></TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Ticker </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Trimestre </TableCell>
									<TableCell sx={{fontSize: '0.65rem', fontWeight: '700'}} align="center"> Data </TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{ lastUpdates.map((asset) => (
									<TableRow key={asset.ticker + asset.fiscalDateEnding}>
										<TableCell sx={{ fontSize: '0.65rem', padding: 0, paddingLeft: 1}}>
											<Box sx={{borderRadius: '25%', backgroundColor: 'lightgray',  width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
												<img src={asset.imageUrl} alt="Company Logo" width={14} height={14}/>
											</Box>
										</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center"><Link to={"/company/"+ asset.ticker} target="_blank">{asset.ticker}</Link></TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{asset.quarter}</TableCell>
										<TableCell sx={{ fontSize: '0.65rem'}} align="center">{asset.releaseDate ? moment(asset.releaseDate).format('DD/MM/YY') : '—'}</TableCell>
									</TableRow>
								))}
							</TableBody>

						</Table>
					</TableContainer>
				<Box textAlign="center" mt={1}>
					<Link to="/calendar?tab=1" style={{ fontSize: '0.7rem' }}>Ver todas</Link>
				</Box>
			</CardContent>
		</Card>
	)
}

export default LastUpdatesCard
